import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { WebGLRenderTarget } from './WebGLRenderTarget.js';

var WebGLMultipleRenderTargets = /*#__PURE__*/function (_WebGLRenderTarget) {
  _inherits(WebGLMultipleRenderTargets, _WebGLRenderTarget);

  var _super = _createSuper(WebGLMultipleRenderTargets);

  function WebGLMultipleRenderTargets(width, height, count) {
    var _this;

    _classCallCheck(this, WebGLMultipleRenderTargets);

    _this = _super.call(this, width, height);
    var texture = _this.texture;
    _this.texture = [];

    for (var i = 0; i < count; i++) {
      _this.texture[i] = texture.clone();
    }

    return _this;
  }

  _createClass(WebGLMultipleRenderTargets, [{
    key: "setSize",
    value: function setSize(width, height) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (this.width !== width || this.height !== height || this.depth !== depth) {
        this.width = width;
        this.height = height;
        this.depth = depth;

        for (var i = 0, il = this.texture.length; i < il; i++) {
          this.texture[i].image.width = width;
          this.texture[i].image.height = height;
          this.texture[i].image.depth = depth;
        }

        this.dispose();
      }

      this.viewport.set(0, 0, width, height);
      this.scissor.set(0, 0, width, height);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.dispose();
      this.width = source.width;
      this.height = source.height;
      this.depth = source.depth;
      this.viewport.set(0, 0, this.width, this.height);
      this.scissor.set(0, 0, this.width, this.height);
      this.depthBuffer = source.depthBuffer;
      this.stencilBuffer = source.stencilBuffer;
      this.depthTexture = source.depthTexture;
      this.texture.length = 0;

      for (var i = 0, il = source.texture.length; i < il; i++) {
        this.texture[i] = source.texture[i].clone();
      }

      return this;
    }
  }]);

  return WebGLMultipleRenderTargets;
}(WebGLRenderTarget);

WebGLMultipleRenderTargets.prototype.isWebGLMultipleRenderTargets = true;
export { WebGLMultipleRenderTargets };